import { render, staticRenderFns } from "./User_Info.vue?vue&type=template&id=1e2236ed&scoped=true&"
import script from "./User_Info.vue?vue&type=script&lang=js&"
export * from "./User_Info.vue?vue&type=script&lang=js&"
import style0 from "./User_Info.vue?vue&type=style&index=0&id=1e2236ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2236ed",
  null
  
)

export default component.exports